export default __webpack_public_path__ + "static/media/results.b26d052a.png";